import { getOwner } from '@ember/owner';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIconFlag, styleEntry } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { IconFlagCode } from '@mylighthouse/prism-ember/types/components/prism/icon-flag';
import { t } from 'ember-intl';
import Countries from 'frontend-utils/utils/countries';
import getChartColor from 'frontend-utils/utils/hotel-chart-color';

interface HotelStrategyTablesCellsTdStrategyHotelSignature {
  Args: {
    cellData: {
      customPOS: IconFlagCode;
      formattedValue: string;
      id: string;
      isOwnHotelInfo: boolean;
    };
  };
}

export default class HotelStrategyTablesCellsTdStrategyHotel extends Component<HotelStrategyTablesCellsTdStrategyHotelSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  private countries: Countries = new Countries(getOwner(this)!);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get bulletColor() {
    return (
      getChartColor(
        this.args.cellData.id,
        this.hotelAndMarketService.primaryAndSecondaryCompetitors,
      ) ?? ''
    );
  }

  get countryName(): string {
    const countryCode = this.args?.cellData?.customPOS?.toUpperCase();
    return this.countries.getName(countryCode);
  }

  get hotelInfoID(): string {
    return `${this.args?.cellData?.id}`;
  }

  <template>
    <div class="text-200--regular flex items-center justify-between">
      <div class="flex items-center justify-start truncate">
        <span
          class="identifier-bullet"
          style={{styleEntry "background-color" this.bulletColor}}
        ></span>
        <span
          class="truncate
            {{if
              @cellData.isOwnHotelInfo
              'text-200--bold text-general-info-600'
            }}"
          title={{@cellData.formattedValue}}
        >{{@cellData.formattedValue}}</span>
      </div>
      {{#if @cellData.customPOS}}
        <PrismIconFlag @code={{@cellData.customPOS}} />
        <EmberTooltip @side="right" @tooltipClass="info-tooltip">
          <p class="text-200--bold">{{t "general.pos_short"}}</p>
          <div class="flex items-center justify-start gap-100">
            <PrismIconFlag @code={{@cellData.customPOS}} />
            <p class="text-200--regular">{{this.countryName}}</p>
          </div>
        </EmberTooltip>
      {{/if}}
    </div>
  </template>
}
